export const villa = [
  {
    title: "ABOUT GRAND BEACH VILLA",
    content: [
      { type: "paragraph", text: "Guests keep saying the same thing: you can be on the sand in under a minute. Grand Beach Villa sits right across from Payyambalam Beach, with sea-view balconies in every room and a host, Rahul, who guests regularly single out for going out of his way to help — whether that's arranging a first trip with a pet or pointing families toward the best nearby spots. It's the kind of place where the common kitchen, the breezy terrace, and the 50-metre walk to the water end up mattering as much as the room itself." },
      { type: "paragraph", text: "Grand Beach Villa is a premium serviced luxury accommodation perfectly situated on the pristine Payyambalam Beach in Kannur. Offering direct access and an unparalleled view of the ocean, it ensures an unforgettable, high-end stay." }
    ]
  },
  {
    title: "ACCOMMODATION DETAILS",
    content: [
      { type: "list", text: "Total Rooms: 7 elegantly designed rooms" },
      { type: "list", text: "Room Types: Deluxe Sea View, Private Balcony with Ocean View, Family room" },
      { type: "list", text: "All rooms feature air conditioning, private bathrooms, and modern furnishings" }
    ]
  },
  {
    title: "AMENITIES",
    content: [
      { type: "list", text: "Complimentary high-speed Wi-Fi is available throughout the entire property." },
      { type: "list", text: "Direct beach access is just steps away." },
      { type: "list", text: "Ironing facilities available" },
      { type: "list", text: "Free on-site parking is provided for all guests." },
      { type: "list", text: "Convenient guest laundry facility available." },
      { type: "list", text: "Fresh linens and towels provided regularly." },
      { type: "list", text: "Communal kitchen and dining space, including a shared refrigerator." },
      { type: "list", text: "Outdoor shower for easily rinsing off after a day at the beach." },
      { type: "list", text: "Ground-level outdoor dining and gathering area (perfect for small events)." },
      { type: "list", text: "Ocean-view terrace—an ideal space for parties, events, or simply enjoying the sea breeze." }
    ]
  },
  {
    title: "LOCATION ADVANTAGES",
    content: [
      { type: "list", text: "Beachfront Setting: Situated right at the heart of Payyambalam Beach, offering immediate access to the sand and surf." },
      { type: "list", text: "Easy Transit: Highly convenient for travelers: just a one-hour drive from Kannur International Airport (CNN) and 20 minutes from Kannur Railway Station." },
      { type: "list", text: "Walkable Neighborhood: Enjoy the convenience of a short walk to local markets, restaurants, and charming cafes." },
      { type: "list", text: "Local Access: Excellent proximity to various major tourist attractions and nearby hotels/eateries." },
      { type: "list", text: "Modern Comforts: Enjoy hassle-free dining with food delivery services (like Swiggy) readily available." }
    ]
  }
];
